import React from 'react'
import { Button } from '@mui/material'

const IconButton = React.forwardRef((props, ref) => {
  return (
    <Button
      color="secondary"
      variant="contained"
      {...props}
      sx={{
        p: 0.5,
        minWidth: 0,
        color:
          (props.variant === 'outlined' && !props.color) ||
          props.color === 'secondary'
            ? 'text.primary'
            : undefined,
        ...props.sx,
      }}
      ref={ref}
    />
  )
})

export default IconButton
